const env = process.env;

export const config = {
  brandName: env.REACT_APP_BRAND_NAME || "BiBa Decor & Events",
  contactEmail: env.REACT_APP_CONTACT_EMAIL || "contact@biba-decor-events.com",
  contactPhone: env.REACT_APP_CONTACT_PHONE || "+221770000000",
  whatsappNumber: env.REACT_APP_WHATSAPP_NUMBER || "221770000000",
  instagramUrl: env.REACT_APP_INSTAGRAM_URL || "",
  facebookUrl: env.REACT_APP_FACEBOOK_URL || "",
  siteUrl:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://biba-decor-events.smndiaye.com",
} as const;

export function telHref(): string {
  return `tel:${config.contactPhone.replace(/\s/g, "")}`;
}

export function mailtoHref(subject?: string): string {
  const base = `mailto:${config.contactEmail}`;
  return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base;
}

export function whatsappHref(message?: string): string {
  const base = `https://wa.me/${config.whatsappNumber}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}
